import { styled } from "@linaria/react"

import { Horizontal } from "@/components/Flex.ts"
import { CloseLight } from "@/icons/Icons.ts"

export const ContextItemPill = styled(Horizontal)<{
  withRemoveIcon: boolean
}>`
  align-items: center;
  gap: 4px;

  height: 32px;
  max-width: 240px;
  padding: ${props => props.withRemoveIcon ? "0 8px" : "0 12px 0 8px"};
  border: 1px solid var(--text-color-10);
  border-radius: var(--border-radius-16);

  cursor: default;
  font-weight: 500;
`

export const ClickableContextItemPill = styled(ContextItemPill)`
  color: var(--text-color);

  &:hover {
    cursor: pointer;
    background-color: var(--text-color-5);
  }
`

export const ContextItemPillRemove = styled(CloseLight)`
  display: flex;

  width: 16px;
  height: 16px;

  margin-left: 2px;

  color: var(--text-color-50);
  transition: color 0.2s ease-in-out;

  &:hover {
    color: var(--text-color);
  }
`
